// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.InputMark_wrapper__37rRG.InputMark_isBlue__179A5 {\n  color: red; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "InputMark_wrapper__37rRG",
	"isBlue": "InputMark_isBlue__179A5"
};
module.exports = exports;
